import superagent from 'superagent';
import superagentAbsolute from 'superagent-absolute';
import notificationHandler from './notificationHandler';
import store from '../store/index';

const currentLang = localStorage.getItem('i18nextLng');
const currentCurrency = localStorage.getItem('currency');

// const rawToken = localStorage.getItem('tulip-token');
// // eslint-disable-next-line operator-linebreak
// const token =
//   rawToken != null ? `${rawToken}`.substr(10, rawToken.length - 12) : '';

// let agent = superagent.agent();
// agent.on('error', (err) => {
//   notificationHandler(err);
// });

// agent = agent.set('Content-Type', 'application/json');
// agent = agent.set('authorization', `Bearer ${token}`);
// agent = agent.type('json');

// const request = superagentAbsolute(agent)(`${process.env.REACT_APP_API_LINK}`);

export default function getAgentInstance() {
  let agent = superagent.agent();
  let lang;
  let currency;

  if (currentLang === 'en-GB') {
    lang = 'en';
  } else {
    lang = currentLang;
  }

  if (currentCurrency === null) {
    currency = 2;
  } else {
    currency = currentCurrency;
  }

  agent.on('error', (err) => {
    notificationHandler(err);
  });
  const rawToken = localStorage.getItem('tulip-token');
  // eslint-disable-next-line operator-linebreak
  const token =
    rawToken != null ? `${rawToken}`.substr(10, rawToken.length - 12) : '';

  agent = agent.set('Content-Type', 'application/json');
  agent = agent.set(
    'authorization',
    `Bearer ${store.tokenStore.value || token}`,
  );
  agent = agent.set('lang', lang);
  agent = agent.set('currency_id', currency);
  agent = agent.type('json');

  const request = superagentAbsolute(agent)(
    `${process.env.REACT_APP_API_LINK}`,
  );
  return request;
}
